// extracted by mini-css-extract-plugin
module.exports = {"emptyGroupContainer":"_emptyGroupContainer--265Oo"};